import Typography from "@mui/material/Typography";
import {MAX_SHARE_MESSAGE_LENGTH} from "./shareLimits";

/**
 * Visible "used / max" character counter for the personal share message (DE-1843). Deliberately not a live
 * region, so a screen reader does not announce every keystroke.
 *
 * @param {number} length - Characters typed so far.
 */
export const ShareMessageCounter = ({length}) => (
    <Typography variant="caption" color="text.secondary" component="div" sx={{textAlign: 'right'}}>
        {`${length} / ${MAX_SHARE_MESSAGE_LENGTH}`}
    </Typography>
);
